module.exports = "<input class=\"weui_input\" v-model=\"value\">";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./components/cells/cell-input.vue
 ** module id = 87
 ** module chunks = 0
 **/